import ServiceResponseError from '@src/error/ServiceResponseError';
import ServiceResponse from '@src/models/ServiceResponse';

export default async function wrapAfterServicePromise(requestFn, { useRawResponse, requestOptions }) {
  /**
   * 当网络离线时, 直接返回离线异常
   */
  if (navigator && navigator.onLine === false) {
    throw new ServiceResponseError(new ServiceResponse(ServiceResponse.ClientError.Offline));
  }
  return requestFn()
    .then(response => {
      if (useRawResponse) {
        return response;
      }
      return new ServiceResponse(response);
    })
    .catch(error => {
      if (error.message === 'Timeout') {
        throw new ServiceResponseError(new ServiceResponse(ServiceResponse.ClientError.Timeout));
      }
      if (ServiceResponse.isApiResponseShape(error)) {
        // noinspection JSCheckFunctionSignatures
        error = new ServiceResponse({ ...error, requestOptions });
        throw new ServiceResponseError(error);
      }
      throw error;
    });
}
